(() => {
  const SELECTOR = '[data-cardemto-tabs]';

  function activateTab(section, button) {
    const target = button.dataset.tabTarget;
    section.querySelectorAll('[data-tab-target]').forEach((tab) => {
      const isActive = tab === button;
      tab.classList.toggle('is-active', isActive);
      tab.setAttribute('aria-selected', String(isActive));
      tab.tabIndex = isActive ? 0 : -1;
    });

    section.querySelectorAll('[data-tab-panel]').forEach((panel) => {
      const isActive = panel.dataset.tabPanel === target;
      panel.classList.toggle('is-active', isActive);
      panel.hidden = !isActive;
    });
  }

  function initializeTabs(root = document) {
    root.querySelectorAll(SELECTOR).forEach((section) => {
      if (section.dataset.tabsReady === 'true') return;
      section.dataset.tabsReady = 'true';

      const tabs = Array.from(section.querySelectorAll('[data-tab-target]'));
      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => activateTab(section, tab));
        tab.addEventListener('keydown', (event) => {
          if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          let nextIndex = index;
          if (event.key === 'ArrowLeft') nextIndex = (index - 1 + tabs.length) % tabs.length;
          if (event.key === 'ArrowRight') nextIndex = (index + 1) % tabs.length;
          if (event.key === 'Home') nextIndex = 0;
          if (event.key === 'End') nextIndex = tabs.length - 1;
          tabs[nextIndex].focus();
          activateTab(section, tabs[nextIndex]);
        });
      });
    });
  }

  document.addEventListener('DOMContentLoaded', () => initializeTabs());
  document.addEventListener('shopify:section:load', (event) => initializeTabs(event.target));
})();
